export function formatNumberWithGrouping(value: number, maximumFractionDigits = 2, minimumFractionDigits = 0): string {
  return value.toLocaleString("en-GB", {maximumFractionDigits, minimumFractionDigits})
}

export function formatNumberWithoutGrouping(value: number, maximumFractionDigits = 2, minimumFractionDigits = 0): string {
  return value.toLocaleString("en-GB", {maximumFractionDigits, minimumFractionDigits, useGrouping: false})
}
